// Pieces of the page shell shared by the browser and the build-time pre-render.
import { h } from './dom';
import { checkView } from './check';
import { bulkView } from './bulk';
import { settingsView } from './settings';
import type { Tab } from '../routes';

/** Placeholder previews shown while Google's fonts load (Check can't measure before that). */
export function loadingView(): HTMLElement {
  return h('div', { class: 'loading', role: 'status' },
    h('div', { class: 'skeleton-frames', 'aria-hidden': 'true' }, [393, 360, 684].map(w => h('div', { class: 'skeleton', style: { width: `min(${w}px, 100%)` } }))),
    h('p', { class: 'muted' }, 'Loading Google’s fonts…'));
}

export function makeView(tab: Tab): HTMLElement {
  return tab === 'check' ? checkView() : tab === 'bulk' ? bulkView() : settingsView();
}
